var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFuelTypeDiesel24 = function SvgFuelTypeDiesel24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.696 10.544a7.465 7.465 0 0 1 .594 7.389 7.172 7.172 0 0 1-2.456 2.884 6.838 6.838 0 0 1-3.537 1.177 6.807 6.807 0 0 1-3.62-.862 7.112 7.112 0 0 1-2.684-2.658A7.438 7.438 0 0 1 5 14.769a7.44 7.44 0 0 1 .979-3.71l.538-.852L12.019 2l5.677 8.544Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.5 7.5 21M16 8 6 18m8-13L5 15m14-1-8 8",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
export default SvgFuelTypeDiesel24;